<span [innerHTML]="title" [ngClass]="getClasses()" class="pill-text"></span>
